<template>
  <el-container>
    <el-main style="padding: 0">
      <div>
        <span>生产入库扫描</span>
        <el-divider />
        <el-form ref="form" class="form" label-width="80px" style="width: 500px" @submit.native.prevent>
          <el-form-item label="序列号">
            <el-input ref="snInput" v-model.trim="snSerialNo" placeholder="请扫描序列号" @keyup.enter.native="snInput" />
          </el-form-item>
          <el-form-item label="仓库条码">
            <el-input
              :disabled="!snSerialNo"
              ref="wareInput"
              v-model.trim="jsonStr"
              placeholder="请扫描仓库条码"
              @keyup.enter.native="wareInput"
            />
          </el-form-item>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  watch: {
    snSerialNo: {
      handler(val) {
        if (!val) {
          this.jsonStr = "";
        }
      },
    },
  },
  data() {
    return {
      snSerialNo: "",
      jsonStr: "",
    };
  },
  mounted() {
    this.$refs.snInput.focus();
  },
  methods: {
    snInput() {
      if (this.snSerialNo) {
        this.$refs.wareInput.focus();
      }
    },

    wareInput() {
      let params = {
        snSerialNo: this.snSerialNo,
        jsonStr: this.jsonStr,
      };
      this.$http.post("basic", "scanRecords/production", "", params).then((res) => {
        if (res.success) {
          this.$message.success("操作成功");
          this.snSerialNo = "";
          this.jsonStr = "";
          this.$refs.snInput.focus();
        }
      });
    },
  },
};
</script>
